<template>
  <div>
    <role-table />
  </div>
</template>

<script>
  import RoleTable from './pogs-roles__table'

  export default {
    components: {
      RoleTable
    }
  }
</script>

<style scoped>

</style>
